import styled from 'styled-components'

export const MapViewer = styled.div`
  width: 100%;
  height: calc(100vh - 80px);
`
